var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"d-flex align-center justify-content-center",attrs:{"span":24}},[_c('lottie-player',{staticStyle:{"width":"150px"},attrs:{"autoplay":"","loop":"","mode":"normal","src":"/static/lottie/holacon-loading-mini-500px-lottie.json"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b501d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HolaconLottie.vue
// module id = null
// module chunks = 